var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-page"},[_vm._m(0),_c('ApartsList',{attrs:{"favorites":true}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-page__intro"},[_c('div',{staticClass:"texts"},[_vm._v("Ваш список понравившихся резиденций")])])
}]

export { render, staticRenderFns }